export const AllowedFsgmLocaleTypes = [
  'en-US',
  'en-GB',
  'fr-FR',
  'sv-SE',
  'nl-NL',
] as const;

export type FsgmLocaleType = (typeof AllowedFsgmLocaleTypes)[number];
